module.exports = __webpack_public_path__ + "img/Hamac mezzanine.f07c51b8.jpg";